import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const createNewTimelineService = async (projectId, timelineDetails) => {
  const host = process.env.REACT_APP_WORK_CALENDAR_API_URL;
  const apiPath = `timelines/project/${projectId}/new-timeline`;

  const request = {
    url: `https://${host}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: host,
    path: apiPath,
    method: 'POST',
    body: JSON.stringify(timelineDetails),
    data: timelineDetails,
    headers: {
      'Content-Type': 'application/json',
    },
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);
  const response = await axios(signedRequest);

  return response.data;
};
